import { getBytesCount } from "@utils/data"

const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback, context) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    let totalNum = getBytesCount(value)
    const isHasBrandName = (context.self_form.xhsShopBrandList || []).some(brand => value.includes(brand.brandName))

    if (totalNum > 60 || totalNum < 16) {
        callback(new Error('标题长度需要在[8]-[30]个字或[16]-[60]个字符'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else if(isHasBrandName) {
        callback(new Error('不能包含品牌名称'));
    } else {
        callback();
    }
}
const validateSubTitle = (rule, value, callback, context) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    const splitArr = (value || '').split('')
    let totalNum = splitArr.length;
    if (totalNum > 18) {
        callback(new Error('字符数不能超过18'))
    } else if (regx.test(value)) {
        callback(new Error('不能含emoj表情'));
    } else {
        callback();
    }
}
const validateDescriptionsImgs = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum < 1) {
        callback(new Error('至少要选择1张图片'));
    } else if (context.$refs.imageDescriptionsList) {
        let $imageDescriptionsList = context.$refs.imageDescriptionsList;
        let imgs = $imageDescriptionsList.$el.querySelectorAll('.originImg') || [];
        let heights=0;

        let errMsg = await $imageDescriptionsList.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else if(imgs){
            function handleImageLoad(img) {
                let height = img.naturalHeight || img.height;
                heights += height;
                if(heights>50000){
                    callback(new Error('图片高度总和不得超过50000px'));
                    return
                }
            }
            imgs.forEach(img=>{
                if (img.complete) {
                    handleImageLoad(img);
                } else {
                    img.addEventListener('load', function () {
                        handleImageLoad(img);
                    });
                }
            })
        }else{
            callback();
        }
    } else  {
        callback()
    }
}

const validateHeadImgs = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum < 1) {
        callback(new Error('至少要选择1张图片'));
    } else if (sum > 10) {
        callback(new Error('图片数量需小于等于10张'));
    } else if (context.$refs.imageList) {
        let errMsg = await context.$refs.imageList.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
}

const validateDescInfo = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum > 20) {
        callback(new Error('图片数量需小于等于20张'));
    } else if (context.$refs.descInfo) {
        let errMsg = await context.$refs.imageList.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
    
}
const validateTransparentImage = async (rule, value, callback, context) => {
    if (context.$refs.transparentImage) { 
        let errMsg = await context.$refs.transparentImage.method_validImage()
        if (errMsg) {
            const regex = /宽度|长度|长宽/;
            if(regex.test(errMsg)){
                context.hasSizeError = true;
            }else{
                context.hasSizeError = false;
            }
            callback(new Error(errMsg));
        } else {
            callback();
            context.hasSizeError = false;
        }
    } else {
        callback();
    }
    
}



// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目'},
            {validator: validateCategoryIds}
        ],
        imageList: [
            {required: true, message: '至少选择1张图片'},
            {validator: contextWrap(validateHeadImgs, context)}
        ],
        imageDescriptionsList:[
            {required: true, message: '至少选择1张图片'},
            {validator: contextWrap(validateDescriptionsImgs, context)}
        ],
        xhsShopLogisticsPlanList:[
            {required: true, message: '请选择物流模版'},
        ],
        xhsShopShippingTemplateList:[
            {required: true, message: '请选择运费模版'},
        ],
        descInfo: [
            {validator: contextWrap(validateDescInfo, context)}
        ],
        name: [
            {required: true, message: '请输入商品标题'},
            {validator: contextWrap(validateTitle, context)},
        ],
        transparentImage:[
            { validator: contextWrap(validateTransparentImage, context)}
        ],
        // brandId:[{required: true, message: '请选择品牌'}],
        subTitle: [
            {validator: contextWrap(validateSubTitle, context)},
        ],
        specifications:[{required: true, message: '请填写规格'}],
        'deliveryTimeObject.option' : [
            {required: true, message: '请选择是否预售'},
        ],
        'deliveryTimeObject.time' : [
            {required: true, message: '请填写发货时间'},
        ],
        'deliveryTimeObject.preSaleTime' : [
            {required: true, message: '请填写预售发货时间'},
        ]
    };
}


export {
    RULES as default,
}
